module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABtSURBVCiR1VE5DoAwDHMQ3dsX0Y9Bof0YvAj2DGHpwNEgARISXh3HiQ0UYBMHF1lsYl/iAaDSiIzmqVDF90LKAex+IYEH4AGMQhiPoqU1A7nIctdt7gzVQuhPZ1w7TurGTY9Bm/lRHZpQD+AtVqLVIGdBSM9NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/table_jia.png
// module id = QDdH
// module chunks = 3